import { useState } from "react";
import { tickerNews } from "@/mocks/blackdata";

const navLinks = [
  { href: "#streamer", label: "主播塌房实锤" },
  { href: "#celebrity", label: "网红翻车名单" },
  { href: "#drama", label: "直播丑闻录屏" },
  { href: "#timeline", label: "实锤时间线" },
  { href: "#figure", label: "人物档案" },
  { href: "#rank", label: "热度榜" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* 更新条压顶：实时滚动条 */}
      <div className="w-full bg-background-950 text-background-50 overflow-hidden">
        <div className="flex items-stretch h-10 md:h-11 max-w-[1400px] mx-auto px-3 md:px-6">
          <div className="flex items-center gap-2 shrink-0 pr-3 md:pr-4 border-r border-background-50/15">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-500 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-500"></span>
            </span>
            <span className="font-heading text-[13px] tracking-wide whitespace-nowrap">实况更新</span>
          </div>
          <div className="relative flex-1 overflow-hidden ml-3 md:ml-4">
            <div className="flex w-max animate-ticker">
              {[0, 1].map((dup) => (
                <div key={dup} className="flex shrink-0" aria-hidden={dup === 1}>
                  {tickerNews.map((t, i) => (
                    <span key={`${dup}-${i}`} className="flex items-center gap-2 text-[12px] md:text-[13px] text-background-100/90 whitespace-nowrap pr-10">
                      <i className="ri-arrow-right-s-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                      {t}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <header className="sticky top-0 z-40 bg-background-50/92 backdrop-blur border-b border-background-200">
        <div className="max-w-[1400px] mx-auto px-3 md:px-6">
          <div className="flex items-center justify-between h-14 md:h-16">
            {/* logo */}
            <a href="#top" className="flex items-center gap-2 shrink-0">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-background-50">
                <i className="ri-flashlight-fill text-lg w-5 h-5 flex items-center justify-center"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl md:text-2xl text-foreground-950 tracking-wide">快手黑料</span>
                <span className="text-[10px] text-foreground-500 mt-1 tracking-[0.18em]">吃瓜前 · 先看名单</span>
              </span>
            </a>

            {/* 桌面菜单 */}
            <nav className="hidden md:flex items-center gap-1 lg:gap-2">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="px-3 py-2 rounded-md text-sm text-foreground-700 hover:text-primary-700 hover:bg-primary-50 transition-colors whitespace-nowrap"
                >
                  {l.label}
                </a>
              ))}
            </nav>

            <div className="flex items-center gap-2 md:gap-3">
              <div className="hidden lg:flex items-center gap-2 bg-background-100 border border-background-200 rounded-md px-3 h-10 w-56">
                <i className="ri-search-line text-foreground-500 w-4 h-4 flex items-center justify-center"></i>
                <input
                  className="bg-transparent outline-none text-sm text-foreground-800 w-full placeholder:text-foreground-400"
                  placeholder="搜人物 / 事件 / 证据…"
                />
              </div>
              <a
                href="#rank"
                className="hidden md:inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 text-background-50 px-4 h-10 text-sm font-medium hover:bg-primary-700 transition-colors"
              >
                <i className="ri-bell-fill w-4 h-4 flex items-center justify-center"></i>
                订阅更新
              </a>
              <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                aria-label="菜单"
                className="md:hidden flex items-center justify-center h-10 w-10 rounded-md text-foreground-800 bg-background-100 border border-background-200"
              >
                <i className={`${open ? "ri-close-line" : "ri-menu-2-line"} text-xl w-5 h-5 flex items-center justify-center`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* 移动菜单 */}
        {open && (
          <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
            <div className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-md px-3 h-10 mb-3">
              <i className="ri-search-line text-foreground-500 w-4 h-4 flex items-center justify-center"></i>
              <input className="bg-transparent outline-none text-sm w-full placeholder:text-foreground-400" placeholder="搜人物 / 事件 / 证据…" />
            </div>
            <div className="flex flex-col gap-1">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="px-2 py-2.5 rounded-md text-[15px] text-foreground-800 hover:bg-primary-50 hover:text-primary-700"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </header>
    </>
  );
}